import * as jsxRuntime from "/Users/apple/Desktop/ProvioAdmin/proviohq/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment